import { IconPaw, IconDna, IconDental, IconReportMedical, IconBone, IconEyeCheck, IconPalette, IconHeartbeat } from '@tabler/icons-react';

export const healthData = [
    {
        icon: IconDna,
        color: 'green',
        title: 'Dog Genetic Identification',
        description:
            ['DNA ISAG 2006', 'Antagene: 759 218'],
    },
    {
        icon: IconDental,
        color: 'green',
        title: 'Dentition',
        description:
            ['Full dentition with correct scissors bite.', 'OFA: STA-DE49/25M-VPI'],
    },
    {
        icon: IconBone,
        color: 'gray',
        title: 'Hip Dysplasia - HD',
        description:
            ['Result: pending testing...', 'OFA: pending registration...'],
    },
    {
        icon: IconBone,
        color: 'green',
        title: 'Elbow Dysplasia - ED',
        description:
            ['Result: ED 0/0', 'OFA: pending registration...'],
    },
    {
        icon: IconBone,
        color: 'green',
        title: 'Osteochondritis Dissecans - OCD',
        description:
            ['OCD Shoulder Free', 'OFA: pending registration...'],
    },
    {
        icon: IconBone,
        color: 'green',
        title: 'Patellar Luxation - PL',
        description:
            ['PL N/N', 'OFA: pending registration...'],
    },
    {
        icon: IconHeartbeat,
        color: 'green',
        title: 'Congenital Heart Disease',
        description:
            ['Result: Normal', 'OFA: STA-BCA232/35M/P-VPI'],
    },
    {
        icon: IconReportMedical,
        color: 'gray',
        title: 'Autoimmune Thyroiditis',
        description:
            ['Result: pending testing...', 'OFA: pending registration...'],
    },
    {
        icon: IconReportMedical,
        color: 'orange',
        title: 'Neuronal Ceroid Lipofuscinosis - NCL-A',
        description:
            ['Autosomal recessive', 'NCL-A Carrier', 'OFA: STA-NCL789/13M-PI-CAR'],
    },
    {
        icon: IconReportMedical,
        color: 'green',
        title: 'Hyperuricosuria - HUU',
        description:
            ['Autosomal recessive.', 'HUU Clear', 'OFA: STA-HU52/13M-PI'],
    },
    {
        icon: IconReportMedical,
        color: 'green',
        title: 'Degenerative Myelopathy - DM',
        description:
            ['Autosomal recessive.', 'DM Clear', 'OFA: STA-DM111/29M-PI'],
    },
    {
        icon: IconReportMedical,
        color: 'green',
        title: 'Amstaff Juvenile Laryngeal Paralysis / Polyneuropathy',
        description:
            ['Autosomal recessive', 'ALPP Clear', 'OFA: STA-ALP18/29M-PI'],
    },
    {
        icon: IconReportMedical,
        color: 'green',
        title: 'Craniomandibular Osteopathy',
        description:
            ['Autosomal dominant with incomplete penetrance', 'CO Clear', 'OFA: STA-CMO1/29M-PI'],
    },
    {
        icon: IconEyeCheck,
        color: 'green',
        title: 'Progressive Retinal Atrophy',
        description:
            ['Autosomal recessive', 'PRA-crd1 Clear, PRA-crd2 Clear, PRA-prcd Clear', 'OFA: STA-PRA6/29M-PI'],
    },
    {
        icon: IconReportMedical,
        color: 'green',
        title: 'Multidrug Sensitivity - MDR1',
        description:
            ['Autosomal codominant.', 'MDR1 Clear', 'OFA: STA-MD1-1/29M-PI-N/N'],
    },
    {
        icon: IconPalette,
        color: '',
        title: 'A Locus - Agouti',
        description:
            ['Autosomal recessive', 'aʷ/aʷ, Aʸ/Aʸ - non-carrier of tricolor'],
    },
    {
        icon: IconPalette,
        color: '',
        title: 'B Locus - Brown',
        description:
            ['Autosomal recessive', 'B/B - non-carrier of brown pigmentation'],
    },
    {
        icon: IconPalette,
        color: '',
        title: 'D Locus - Dilution',
        description:
            ['Autosomal recessive', 'D/d - carrier of dilution'],
    },
    {
        icon: IconPalette,
        color: '',
        title: 'E Locus - Extension',
        description:
            ['Autosomal recessive', 'Eᵐ/E - melanistic mask'],
    },
    {
        icon: IconPalette,
        color: '',
        title: 'K Locus - Dominant Black',
        description:
            ['Autosomal dominant', 'kʸ/kʸ - not expressed'],
    },
    {
        icon: IconPaw,
        color: '',
        title: 'Shedding - MC5R',
        description:
            ['Autosomal codominant', 'Low shedding'],
    },
    // {
    //     icon: IconPaw,
    //     color: '',
    //     title: 'Polydactyly',
    //     description:
    //         ['Autosomal dominant', 'Non-carrier of polydactyly'],
    // },
];